import React, { useContext, useState } from "react";
import { Box, Button, Grid, InputAdornment, TextField, Dialog , DialogContent, Typography} from '@mui/material';
import { AccountCircle,AddBusiness,ContactPhone,EmailOutlined,PhoneAndroidOutlined,PinDrop,Store,} from "@mui/icons-material";

import { callPostApi } from "../../function/ApiCallFunction";
import GradientLoader from "../CommanComponents/GradientLoader";
import { toast } from "react-toastify";
import cashiPluslogo from "../../assets/CashiPluslogo.png"
import { DataContext } from "../../context/DataContext";

export default function StorePlusInfo({ quiet = false }) 
{
    /* ===================== USER & STORE INFO ===================== */
    const {loginData } = useContext(DataContext);
    const storeInfo  = loginData?.store_info || {};

    const store_id        = storeInfo.store_id || "";
    const store_name      = storeInfo.store_name?.length > 19 ? `${storeInfo.store_name.substring(0, 19)}...` : storeInfo.store_name || "";
    const store_image     = storeInfo.store_image || cashiPluslogo;
    const owner_name      = storeInfo.owner_name || "";
    const email           = storeInfo.email || "";
    const contact_mobile  = storeInfo.contact_mobile || "";
    const cashi_app_name  = storeInfo.cashi_app_name || "";
    const storeAddress    = [storeInfo.area_name,storeInfo.city_name,storeInfo.state_name,].filter(Boolean).join(", ");
    
    const loyaltyLink = 'https://play.google.com/store/apps/details?id=com.loyalty.cashi&hl=en_IN';

    /* ===================== STATE ===================== */
    const [loading, setLoading] = useState(false);
    const [appname, setAppname] = useState(cashi_app_name);
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => { setOpen(true); };
    const handleClose = () => { setOpen(false); };
  
    /* ===================== UPDATE APP NAME API ===================== */
    const appNameApi = async () => 
    {
        if (!appname.trim()) { toast.warning("App name cannot be empty!"); return; }
        try 
        {
            setLoading(true);
            
            const payload = { mod: "STORE_UPDATE", data_arr: { store_id, cashi_app_name: appname }};

            const apiResult = await callPostApi("store-update", payload);

            if (apiResult.status === "200") 
            {
              toast.success("App name updated successfully!");
            } 
            else 
            {
              toast.info("Failed to update app name. Please try again.");
            }
        } 
        catch (err) { } 
        finally { setLoading(false); }
    };

  return (
    <>
        {loading && <GradientLoader text="Loading" />}

        {quiet ? (
          <Box onClick={handleClickOpen} sx={{ cursor: "pointer", minWidth: 0 }}>
            <Typography noWrap sx={{ fontSize: 13.5, fontWeight: 650, color: "#fff" }}>{store_name}</Typography>
            <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>Store account</Typography>
          </Box>
        ) : (
          <Button sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)", px: "7px",py: "5px",borderRadius: "6px",my: "5px",color: "#fff",}}
            onClick={handleClickOpen} > <Store /> {store_name}
          </Button>
        )}

        <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
        <DialogContent>
          <DialogContent id="alert-dialog-description">

            <Grid container spacing={2}>

                <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{ textAlign: "right" }}>
                  <img src={store_image} alt="Store" style={{ width: "60px", marginLeft: "4px" }} />
                </Grid>

                {/* Store Name */}
                <Grid item size={{ xs: 12,sm:12, md: 12,}}>
                    <TextField label="Store Name" value={storeInfo.store_name || ""} fullWidth variant="standard"
                        slotProps={{ input: { startAdornment: ( <InputAdornment position="start"> <Store sx={{ color:'#1A73E8' }} /></InputAdornment>),  
                              style:{color:'#000', fontWeight:500, pointerEvents: 'none' }},}} />
                </Grid>

                {/* Address */}
                <Grid item size={{ xs: 12,sm:12, md: 12,}}>
                  <TextField label="Store Address" multiline maxRows={2} value={storeAddress} fullWidth variant="standard"
                      slotProps={{  input: {  startAdornment: ( <InputAdornment position="start"> <PinDrop sx={{ color:'#1A73E8' }} /> </InputAdornment> ), 
                            style:{color:'#000', fontWeight:500, pointerEvents: 'none'}}, }} />
                </Grid>

                <Grid item size={{ xs: 12,sm:12, md: 6,  }}>
                    <TextField label="Contact Name" value={owner_name} fullWidth variant="standard"
                        slotProps={{ input: { startAdornment: ( <InputAdornment position="start"> <AccountCircle sx={{ color:'#1A73E8' }}  /> </InputAdornment> ), 
                          style:{color:'#000', fontWeight:500, pointerEvents: 'none'} }, }}  />
                </Grid>
      
                <Grid item size={{ xs: 12,sm:12, md: 6,  }}>
                  <TextField label="Contact Number" value={contact_mobile} fullWidth variant="standard"
                      slotProps={{ input: { startAdornment: ( <InputAdornment position="start"> <ContactPhone sx={{ color:'#1A73E8' }}  /></InputAdornment> ),
                          style:{color:'#000', fontWeight:500, pointerEvents: 'none'} }, }}  />
                </Grid>

                <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
                  <TextField label="Email" value={email} fullWidth variant="standard"
                      slotProps={{ input: { startAdornment: ( <InputAdornment position="start"> <EmailOutlined sx={{ color:'#1A73E8' }}  /></InputAdornment> ),
                          style:{color:'#000', fontWeight:500, pointerEvents: 'none'} }, }}  />
                </Grid>
              
                <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
                  <TextField label="App Name" value={appname} fullWidth variant="standard" onChange={(e) => setAppname(e.target.value)}
                    slotProps={{ input: { startAdornment: (<InputAdornment position="start"><PhoneAndroidOutlined sx={{ color: "#1A73E8" }} /></InputAdornment>),
                          style: { color: "#000", fontWeight: 500 } }, }}  />
                </Grid>

                <Grid item size={{ xs: 12, sm: 12, md: 6 }} sx={{ display: "flex", alignItems: "end" }}>
                    {cashi_app_name === "" || cashi_app_name !=='' ? ( <Button variant="contained" sx={{background: "linear-gradient(195deg, #66BB6A, #43A047)", 
                        color: "#fff",}}onClick={() => appNameApi()}> {" "} Update App Name</Button>) : ("")}
                </Grid>

                <Grid item size={{ xs: 12, sm: 12, md: 12 }} className="d-flex justify-content-center align-items-center mt-9">
                    <Button onClick={handleClose} sx={{background: "linear-gradient(195deg, #42424a, #191919)",color: "#fff",px: 2,mx: 1,}}>Close</Button>
                    <a href={loyaltyLink} target="_blank" rel="noopener noreferrer">
                      <Button sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)",color: "#fff",px: 1,}}><AddBusiness /> Manage Stores</Button>
                    </a>                   
                </Grid>

            </Grid>
          </DialogContent>
        </DialogContent>
        </Dialog>
    </>
  );
}
